/* eslint-disable @typescript-eslint/no-magic-numbers */
import { AppPhase, GameType } from '../../models/communication/app-enums.model';
import { AppEventType } from '../../models/communication/app-events.model';
import { YEventPayload } from '../../models/y-protocol.model';
import { BaccaratCardPosition, BaccaratOutcome } from '../main-games/baccarat/baccarat.model';

type Event = Omit<YEventPayload<AppEventType>, 'triggered'>;

export const configuration = {
    gameType: GameType.Baccarat
};

export const demoEvents: Array<Event | Event[]> = [
    {
        name: AppEventType.GamePhaseChange,
        data: {
            phase: AppPhase.DealingCards
        }
    },
    {
        name: AppEventType.CardDealt,
        data: {
            card: 213,
            cardPosition: BaccaratCardPosition.PlayerFirstCard,
            bankerHandValue: 0,
            playerHandValue: 0,
            nextCardPosition: BaccaratCardPosition.BankerFirstCard
        }
    },
    {
        name: AppEventType.CardDealt,
        data: {
            card: 303,
            cardPosition: BaccaratCardPosition.BankerFirstCard,
            playerHandValue: 0,
            bankerHandValue: 3,
            nextCardPosition: BaccaratCardPosition.PlayerSecondCard
        }
    },
    {
        name: AppEventType.PlayerCountChange,
        data: {
            count: 10 + Math.round(Math.random() * 100)
        }
    },
    {
        name: AppEventType.CardDealt,
        data: {
            card: 407,
            cardPosition: BaccaratCardPosition.PlayerSecondCard,
            playerHandValue: 7,
            bankerHandValue: 3,
            nextCardPosition: BaccaratCardPosition.BankerSecondCard
        }
    },
    {
        name: AppEventType.CutCardDrawn
    },
    {
        name: AppEventType.CardDealt,
        data: {
            card: 110,
            cardPosition: BaccaratCardPosition.BankerSecondCard,
            playerHandValue: 7,
            bankerHandValue: 3,
            nextCardPosition: BaccaratCardPosition.PlayerThirdCard
        }
    },
    {
        name: AppEventType.ChatMessage,
        data: {
            // eslint-disable-next-line spellcheck/spell-checker
            content: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nullam id dolor id nibh ultricies vehicula',
            from: 'Dick Tracy',
            timestamp: Date.now()
        }
    },
    {
        name: AppEventType.CardDealt,
        data: {
            card: 201,
            cardPosition: BaccaratCardPosition.PlayerThirdCard,
            playerHandValue: 8,
            bankerHandValue: 3,
            nextCardPosition: BaccaratCardPosition.BankerThirdCard
        }
    },
    [
        {
            name: AppEventType.CardDealt,
            data: {
                card: 304,
                cardPosition: BaccaratCardPosition.BankerThirdCard,
                playerHandValue: 8,
                bankerHandValue: 7,
                outcome: BaccaratOutcome.PlayerWin
            }
        },
        {
            name: AppEventType.GamePhaseChange,
            data: {
                phase: AppPhase.RoundEnd,
                outcome: BaccaratOutcome.PlayerWin
            }
        }
    ]
];
